// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.mobile-navbar-header[data-v-1686d8e7] {\n  background: #2d1f13;\n  background: linear-gradient(180deg, rgba(45, 31, 19, 100%) 0%, rgba(118, 67, 26, 100%) 100%);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
